export default {
  SET_APP_LOADED: "SET_APP_LOADED",
  SET_CURRENT_STEP: "SET_CURRENT_STEP",
  SET_PASSWORD: "SET_PASSWORD",
  SET_PASSWORD_ERROR: "SET_PASSWORD_ERROR",
  SET_PHONE_DATA: "SET_PHONE_DATA",
  SET_LANG: "SET_LANG",
}